(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ora-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
    var DAY = 86400000;

    function parseOffset(v) {
      // "-0600" -> -360 minutes
      var m = /^([+-])(\d{2})(\d{2})$/.exec((v || '').trim());
      if (!m) return null;
      var mins = parseInt(m[2], 10) * 60 + parseInt(m[3], 10);
      return m[1] === '-' ? -mins : mins;
    }

    // A Date whose local getters read as the shop's wall clock.
    function shopNow(offsetMin) {
      var now = new Date();
      if (offsetMin === null) return now;
      return new Date(now.getTime() + offsetMin * 60000 + now.getTimezoneOffset() * 60000);
    }

    function ymd(d) {
      var m = d.getMonth() + 1;
      var day = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
    }

    function numbers(str) {
      var out = {};
      (str || '').split(',').forEach(function (n) {
        n = n.trim();
        if (n !== '') out[parseInt(n, 10)] = true;
      });
      return out;
    }

    function isWorking(d, days, holidays) {
      return !!days[d.getDay()] && !holidays[ymd(d)];
    }

    function nextWorking(d, days, holidays) {
      var out = new Date(d.getTime());
      for (var i = 0; i < 400; i++) {
        if (isWorking(out, days, holidays)) return out;
        out = new Date(out.getTime() + DAY);
      }
      return out;
    }

    function addWorking(d, n, days, holidays) {
      var out = new Date(d.getTime());
      var added = 0;
      for (var i = 0; i < 400 && added < n; i++) {
        out = new Date(out.getTime() + DAY);
        if (isWorking(out, days, holidays)) added++;
      }
      return out;
    }

    function ruleFor(el, country) {
      var raw = el.dataset.rules || '';
      var groups = raw.split(';');
      for (var i = 0; i < groups.length; i++) {
        var parts = groups[i].split('|');
        if (parts.length < 5) continue;
        var list = parts[0]
          .split(',')
          .map(function (c) {
            return c.trim().toUpperCase();
          })
          .filter(Boolean);
        if (list.indexOf(country) > -1) {
          return { pmin: +parts[1], pmax: +parts[2], tmin: +parts[3], tmax: +parts[4] };
        }
      }
      var f = (el.dataset.fallbackRule || '').split('|');
      return { pmin: +f[0] || 0, pmax: +f[1] || 0, tmin: +f[2] || 0, tmax: +f[3] || 0 };
    }

    // Hand-assembling two formatted dates produced things like "15 Tue - Thu, Sep 17":
    // with only weekday and day, Intl orders the fields by locale, and the two ends of
    // the range disagreed. formatRange handles the whole span and elides what is shared.
    function range(a, b) {
      var opts = { weekday: 'short', month: 'short', day: 'numeric' };
      var locale = document.documentElement.lang || 'en-US';
      try {
        var f = new Intl.DateTimeFormat(locale, opts);
        if (ymd(a) === ymd(b)) return f.format(a);
        if (typeof f.formatRange === 'function') return f.formatRange(a, b);
        return f.format(a) + ' – ' + f.format(b);
      } catch (e) {
        return a.toDateString() + ' – ' + b.toDateString();
      }
    }

    function selectedVariantId() {
      var input = document.querySelector('product-form-component form input[name="id"]');
      return input ? String(input.value) : null;
    }

    function render(el) {
      var line = el.querySelector('[data-eta-line]');
      if (!line) return;

      var preorder = {};
      try {
        preorder = JSON.parse(el.dataset.preorder || '{}');
      } catch (e) {
        preorder = {};
      }
      var vid = selectedVariantId();
      if (vid && preorder[vid]) {
        line.textContent = preorder[vid];
        return;
      }

      var offset = parseOffset(el.dataset.utcOffset);
      var now = shopNow(offset);
      var dispatchDays = numbers(el.dataset.dispatchDays);
      var transitDays = numbers(el.dataset.transitDays);
      var holidays = {};
      (el.dataset.holidays || '').split(/[,\s]+/).forEach(function (h) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(h)) holidays[h] = true;
      });

      var rule = ruleFor(el, (el.dataset.country || 'US').toUpperCase());

      // Puerto Rico, Guam and the USVI are US provinces in Shopify's address model,
      // so localization.country returns "US" and they would be quoted a mainland
      // window. The browser's IANA timezone identifies them; these zones are
      // exclusive to those places, and need no permission prompt or lookup service.
      //
      // Alaska and Hawaii are deliberately NOT in this list. 120 days of delivery
      // data says they are as fast as the mainland or faster (AK median 2 business
      // days, HI 3, against a mainland median of 3) because ~88% of them go FedEx
      // air, while the mainland rides a slower ground mix. Quoting them a longer
      // window would be wrong in the pessimistic direction.
      if (el.dataset.remoteUs === 'true') {
        var REMOTE = [
          'Pacific/Guam',
          'Pacific/Saipan',
          'Pacific/Pago_Pago',
          'America/Puerto_Rico',
          'America/St_Thomas',
        ];
        var tz = '';
        try {
          tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        } catch (e) {
          tz = '';
        }
        if (REMOTE.indexOf(tz) > -1) {
          var r = (el.dataset.remoteUsRule || '').split('|');
          if (+r[0] && +r[1]) {
            rule = { pmin: rule.pmin, pmax: rule.pmax, tmin: +r[0], tmax: +r[1] };
          }
        }
      }
      var cutoff = parseInt(el.dataset.cutoffHour, 10);

      // Today counts only if it is a working day and we are still before the cutoff.
      var dispatch = new Date(now.getTime());
      var beforeCutoff = isWorking(dispatch, dispatchDays, holidays) && now.getHours() < cutoff;
      if (!beforeCutoff) {
        dispatch = nextWorking(new Date(now.getTime() + DAY), dispatchDays, holidays);
      }

      var shipMin = addWorking(dispatch, rule.pmin, dispatchDays, holidays);
      var shipMax = addWorking(dispatch, rule.pmax, dispatchDays, holidays);
      var arriveMin = addWorking(shipMin, rule.tmin, transitDays, holidays);
      var arriveMax = addWorking(shipMax, rule.tmax, transitDays, holidays);

      var html = (el.dataset.label || 'Arrives') + ' <strong>' + range(arriveMin, arriveMax) + '</strong>';

      if (el.dataset.countdown === 'true' && beforeCutoff) {
        var msLeft = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff, 0, 0) - now;
        if (msLeft > 0) {
          var hrs = Math.floor(msLeft / 3600000);
          var mins = Math.floor((msLeft % 3600000) / 60000);
          var left = hrs > 0 ? hrs + ' hr' + (hrs === 1 ? '' : 's') : mins + ' min';
          var within = el.dataset.orderWithin || 'order within';
          html += ' — ' + within + ' <strong>' + left + '</strong>';
        }
      }

      line.innerHTML = html;
    }

    function renderAll() {
      document.querySelectorAll('ora-delivery-estimate').forEach(render);
    }

    if (!customElements.get('ora-delivery-estimate')) {
      customElements.define(
        'ora-delivery-estimate',
        class extends HTMLElement {
          connectedCallback() {
            render(this);
          }
        }
      );
    }

    // The variant picker swaps the selected variant without a reload, and a
    // pre-order variant has to take over the line when it does.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker')) {
        setTimeout(renderAll, 0);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function mainPicker() {
      return document.querySelector('variant-picker[data-template-product-match="true"]') || document.querySelector('variant-picker');
    }
    function valueFor(opt) {
      var vp = mainPicker();
      if (!vp) return null;
      var esc = (window.CSS && CSS.escape) ? CSS.escape(opt) : opt;
      var radio = vp.querySelector('fieldset input[data-option-name="' + esc + '"]:checked');
      if (radio) return radio.value;
      var selects = vp.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        var o = selects[i].selectedOptions[0];
        if (o && o.dataset.optionName === opt) return selects[i].value;
      }
      return null;
    }
    function update() {
      var gals = document.querySelectorAll('variant-gallery');
      for (var g = 0; g < gals.length; g++) {
        var el = gals[g];
        var opt = el.getAttribute('data-option');
        if (!opt) continue;
        var val = valueFor(opt);
        var sets = el.querySelectorAll('.variant-gallery__set');
        if (sets.length <= 1) continue;
        var target = null, first = null;
        for (var i = 0; i < sets.length; i++) {
          if (sets[i].querySelector('img') && !first) first = sets[i];
          if (sets[i].getAttribute('data-value') === val) target = sets[i];
          sets[i].hidden = true;
        }
        var show = (target && target.querySelector('img')) ? target : (first || target || sets[0]);
        if (show) show.hidden = false;
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker')) update();
    });
    if (document.readyState !== 'loading') update();
    else document.addEventListener('DOMContentLoaded', update);

    function ensureDialog() {
      var d = document.getElementById('variant-gallery-zoom');
      if (d) return d;
      d = document.createElement('dialog');
      d.id = 'variant-gallery-zoom';
      d.className = 'vmf-zoom-dialog';
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'vmf-zoom-dialog__close';
      close.setAttribute('aria-label', 'Close');
      close.innerHTML = '&times;';
      var im = document.createElement('img');
      im.className = 'vmf-zoom-dialog__img';
      im.alt = '';
      d.appendChild(close);
      d.appendChild(im);
      document.body.appendChild(d);
      close.addEventListener('click', function () { d.close(); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      return d;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.variant-gallery__zoom') : null;
      if (!btn) return;
      e.preventDefault();
      var img = btn.querySelector('img');
      if (!img) return;
      var d = ensureDialog();
      var di = d.querySelector('.vmf-zoom-dialog__img');
      di.src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
      di.alt = img.alt || '';
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-metafield"] && !Shopify.designMode) return;
  try {
    (function () {
    function mainPicker() {
      return document.querySelector('variant-picker[data-template-product-match="true"]') || document.querySelector('variant-picker');
    }
    function valueFor(opt) {
      var vp = mainPicker();
      if (!vp) return null;
      var esc = (window.CSS && CSS.escape) ? CSS.escape(opt) : opt;
      var radio = vp.querySelector('fieldset input[data-option-name="' + esc + '"]:checked');
      if (radio) return radio.value;
      var selects = vp.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        var o = selects[i].selectedOptions[0];
        if (o && o.dataset.optionName === opt) return selects[i].value;
      }
      return null;
    }
    function filled(node){ return node.textContent.trim() !== '' || !!node.querySelector('img'); }
    function update() {
      var blocks = document.querySelectorAll('variant-metafield');
      for (var b = 0; b < blocks.length; b++) {
        var el = blocks[b];
        var opt = el.getAttribute('data-option');
        var val = valueFor(opt);
        var items = el.querySelectorAll('.variant-metafield__value');
        if (!items.length) continue;
        for (var i = 0; i < items.length; i++) items[i].hidden = true;
        var target = null, firstFilled = null;
        for (var j = 0; j < items.length; j++) {
          if (filled(items[j]) && !firstFilled) firstFilled = items[j];
          if (items[j].getAttribute('data-value') === val) target = items[j];
        }
        var show = (target && filled(target)) ? target : (firstFilled || target || items[0]);
        if (show) show.hidden = false;
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker')) update();
    });
    if (document.readyState !== 'loading') update();
    else document.addEventListener('DOMContentLoaded', update);

    function ensureDialog() {
      var d = document.getElementById('vmf-zoom-dialog');
      if (d) return d;
      d = document.createElement('dialog');
      d.id = 'vmf-zoom-dialog';
      d.className = 'vmf-zoom-dialog';
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'vmf-zoom-dialog__close';
      close.setAttribute('aria-label', 'Close');
      close.innerHTML = '&times;';
      var im = document.createElement('img');
      im.className = 'vmf-zoom-dialog__img';
      im.alt = '';
      d.appendChild(close);
      d.appendChild(im);
      document.body.appendChild(d);
      close.addEventListener('click', function () { d.close(); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      return d;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.variant-metafield__zoom') : null;
      if (!btn) return;
      e.preventDefault();
      var img = btn.querySelector('img');
      if (!img) return;
      var d = ensureDialog();
      var di = d.querySelector('.vmf-zoom-dialog__img');
      di.src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
      di.alt = img.alt || '';
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
